import React from 'react';
import { Container } from '@cp/ds/src/components/container';
import { Stack } from '@cp/ds/src/components/stack';
import { Typography } from '@cp/ds/src/components/typography';
import { Link } from '@cp/ds/src/components/link';

export const NotFound = () => (
  <Container>
    <Stack my={{ xs: 4, md: 18 }}>
      <Typography sx={{ textAlign: 'center', mb: 4 }} variant="h4">
        Страница не найдена
      </Typography>
      <Link external href="/" sx={{ textAlign: 'center' }} target="_self">
        Вернуться на главную
      </Link>
    </Stack>
  </Container>
);
